import { PlayArrow, Stop } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Focus } from 'lucide-react';
import { Fragment } from 'react';
import { MovieReviewSlider } from '~/components/Sliders/MovieReviewSlider';
import StructureLabel from '~/components/Structures/StructureLabel';
import { useAutoScroll } from '~/hooks/useAutoScroll';
import useViewManagerEvents from '~/hooks/useViewManagerEvents';
import { ROIState } from '~/state/atoms/structureSet/roiAtoms';

export default function ReviewPlayer({ roi }: { roi: ROIState }) {
    const { setShouldScroll, shouldScroll } = useAutoScroll(roi.roiNumber);
    const handleAutoScroll = () => {
        setShouldScroll(!shouldScroll);
    };
    const { focusOnStructure } = useViewManagerEvents();


    const handleFocusOnStructure = () => {
        focusOnStructure(roi.roiNumber);
    };

    return (
        <Fragment>
            <Stack
                spacing={2}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <StructureLabel roi={roi} />
             

                <Tooltip title={shouldScroll ? 'Stop Movie' : 'Play Movie'}>
                    <IconButton
                        sx={{ backgroundColor: '#00a5b9' }}
                        aria-label="Auto-Scroll Structure"
                        onClick={handleAutoScroll}
                        size="small"
                    >
                        {shouldScroll ? <Stop /> : <PlayArrow />}
                    </IconButton>
                </Tooltip>
            </Stack>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
                <Tooltip title={'Focus'} enterDelay={500} enterNextDelay={500}>
                    <IconButton color="primary" size="small" onClick={handleFocusOnStructure}>
                        <Focus size={16} />
                    </IconButton>
                </Tooltip>
                <MovieReviewSlider />
            </Stack>
        </Fragment>
    );
}
